import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { SecurityGuard } from './security.guard';
import { SecurityInterceptor } from './security.interceptor';
import { SecurityService, options, CONFIG, INITIAL, initial, config, _configFactory } from './security.service';

@NgModule({
  imports: [
    RouterModule
  ],
  providers: [
    SecurityGuard,
    SecurityService
  ],
  declarations: []
})
export class RsmSecurityModule {

  public static forRoot(configValue?: options): ModuleWithProviders<RsmSecurityModule> {
    return {
      ngModule: RsmSecurityModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SecurityInterceptor,
          multi: true
        },
        {
          provide: CONFIG,
          useValue: configValue
        },
        {
          provide: INITIAL,
          useValue: initial
        },
        {
          provide: config,
          useFactory: _configFactory,
          deps: [INITIAL, CONFIG]
        }
      ]
    };
  }
}

